import {
  IconBox,
  IconBrandGithub,
  IconFlame,
  IconGitPullRequest,
  IconRocket,
  IconServer,
  IconSettings,
  IconUser,
  IconUsers,
  IconCircles,
  IconBolt,
} from "@tabler/icons-react";

// Humans
export const IconHumans = IconUser;
export const IconTeam = IconCircles;
export const IconPeople = IconUsers;

// Systems
export const IconDeployment = IconRocket;
export const IconApplication = IconBox;
export const IconEnvironment = IconServer;
export const IconRepository = IconBrandGithub;
export const IconIncident = IconFlame;

// Misc
export const IconPullRequest = IconGitPullRequest;
export const IconSetting = IconSettings;

export const IconAutomation = IconBolt;
